var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01225 13.665C3.15692 13.665 0.833984 11.3421 0.833984 8.48673C0.833984 5.63153 3.15692 3.30859 6.01225 3.30859C8.86745 3.30859 11.1904 5.63153 11.1904 8.48673C11.1904 11.3421 8.86745 13.665 6.01225 13.665ZM6.01225 5.24526C4.22478 5.24526 2.77052 6.69939 2.77052 8.48686C2.77052 10.2743 4.22465 11.7286 6.01225 11.7286C7.79958 11.7286 9.25399 10.2745 9.25399 8.48686C9.25385 6.69939 7.79958 5.24526 6.01225 5.24526Z",
    fill: "#50C8EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 5.5103H12.23V2.26856H8.98828V0.332031H14.1665V5.5103Z",
    fill: "#50C8EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5137 0.617188L13.8828 1.98632L9.67351 6.19561L8.30438 4.82648L12.5137 0.617188Z",
    fill: "#50C8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMen);
export default __webpack_public_path__ + "static/media/icon-men.361929bf36ecc8e20ffabec2139df7d7.svg";
export { ForwardRef as ReactComponent };